var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('message-alert'),_vm._v(" "),_c('v-main',[_c('v-container',{staticClass:"pa-0 bg-white",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }